import React, { useState } from 'react';
import './ManutencaoModal.css';

interface ManutencaoModalProps {
  open: boolean;
  onClose: () => void;
  checklist: {
    id: number;
    placa: string;
    banco_rasgado: number;
    todas_travessas: number;
    faltam_travessas: number;
    todas_travessas_correntes: number;
    todas_colunas_correntes: number;
    colunas_sem_corrente: string;
    sistema_pneumatico_vazamento: number;
    sistema_pneumatico_levanta4: number;
    banheira_pintada: number;
    freio_ok: number;
    todas_fivelas_instaladas: number;
    faltam_fivelas: number;
    pneus_condicao?: string;
  };
}

const ManutencaoModal: React.FC<ManutencaoModalProps> = ({ open, onClose, checklist }) => {
  const [form, setForm] = useState({
    banco_rasgado_resolvido: false,
    travessas_resolvido: false,
    travessas_correntes_resolvido: false,
    colunas_correntes_resolvido: false,
    sistema_pneumatico_vazamento_resolvido: false,
    sistema_pneumatico_levanta4_resolvido: false,
    banheira_pintada_resolvido: false,
    freio_ok_resolvido: false,
    fivelas_resolvido: false,
    pneus_resolvido: false,
    lona_feita: '',
    lona_lado: '',
    observacoes_manutencao: '',
    usuario: ''
  });

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setForm({ ...form, [name]: checked });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const payload = {
      checklist_id: checklist.id,
      placa: checklist.placa,
      ...form
    };

    try {
      const res = await fetch('/api/checklist/manutencao', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        alert('Manutenção registrada com sucesso!');
        setForm({
          banco_rasgado_resolvido: false,
          travessas_resolvido: false,
          travessas_correntes_resolvido: false,
          colunas_correntes_resolvido: false,
          sistema_pneumatico_vazamento_resolvido: false,
          sistema_pneumatico_levanta4_resolvido: false,
          banheira_pintada_resolvido: false,
          freio_ok_resolvido: false,
          fivelas_resolvido: false,
          pneus_resolvido: false,
          lona_feita: '',
          lona_lado: '',
          observacoes_manutencao: '',
          usuario: ''
        });
        onClose();
        window.dispatchEvent(new Event('checklist-updated'));
      } else {
        alert('Erro ao registrar manutenção!');
      }
    } catch (err) {
      console.error(err);
      alert('Erro ao conectar ao backend!');
    }
  };

  if (!open) return null;

  // Lista de pendências do checklist
  const pendencias = [];
  if (checklist.banco_rasgado) pendencias.push({ key: 'banco_rasgado_resolvido', label: 'Banco rasgado' });
  if (!checklist.todas_travessas) pendencias.push({ key: 'travessas_resolvido', label: `Travessas faltando (${checklist.faltam_travessas || '?'})` });
  if (!checklist.todas_travessas_correntes) pendencias.push({ key: 'travessas_correntes_resolvido', label: 'Travessas sem correntes' });
  if (!checklist.todas_colunas_correntes) pendencias.push({ key: 'colunas_correntes_resolvido', label: `Colunas sem correntes ${checklist.colunas_sem_corrente ? '(' + checklist.colunas_sem_corrente + ')' : ''}` });
  if (checklist.sistema_pneumatico_vazamento) pendencias.push({ key: 'sistema_pneumatico_vazamento_resolvido', label: 'Sistema pneumático com vazamento' });
  if (!checklist.sistema_pneumatico_levanta4) pendencias.push({ key: 'sistema_pneumatico_levanta4_resolvido', label: 'Não levanta os 4 lados' });
  if (!checklist.banheira_pintada) pendencias.push({ key: 'banheira_pintada_resolvido', label: 'Banheira não pintada' });
  if (!checklist.freio_ok) pendencias.push({ key: 'freio_ok_resolvido', label: 'Freio não está OK' });
  if (!checklist.todas_fivelas_instaladas) pendencias.push({ key: 'fivelas_resolvido', label: `Fivelas faltando (${checklist.faltam_fivelas || '?'})` });
  if (checklist.pneus_condicao && checklist.pneus_condicao !== 'bons') pendencias.push({ key: 'pneus_resolvido', label: `Pneus (${checklist.pneus_condicao === 'marca_fogo' ? 'marca de fogo' : 'com avaria'})` });

  return (
    <div className="manutencao-modal-overlay" onClick={onClose}>
      <div className="manutencao-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="manutencao-modal-header">
          <h2>🔧 Registrar Manutenção - {checklist.placa}</h2>
          <button className="manutencao-modal-close" onClick={onClose} type="button">×</button>
        </div>
        
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
          <div className="manutencao-form-body">
            <div className="manutencao-info-box">
              <p><strong>Marque os itens que foram resolvidos:</strong></p>
            </div>

            {pendencias.length === 0 ? (
              <div className="manutencao-no-pendencias">
                Nenhuma pendência encontrada para esta carreta.
              </div>
            ) : (
              <div className="manutencao-checklist-items">
                {pendencias.map(item => (
                  <label key={item.key} className="manutencao-checkbox-item">
                    <input
                      type="checkbox"
                      name={item.key}
                      checked={(form as any)[item.key]}
                      onChange={handleCheckboxChange}
                    />
                    <span className="manutencao-checkbox-label">{item.label}</span>
                  </label>
                ))}
              </div>
            )}

            <div className="manutencao-form-group">              <label>Foi feita a lona?</label>
              <select
                name="lona_feita"
                value={form.lona_feita}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '2px solid #e1e8ed',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                  transition: 'border-color 0.2s',
                  boxSizing: 'border-box'
                }}
              >
                <option value="">Selecione</option>
                <option value="sim">Sim</option>
                <option value="nao">Não</option>
              </select>
            </div>

            {form.lona_feita === 'sim' && (
              <div className="manutencao-form-group">
                <label>Qual lado da lona foi feito?</label>
                <select
                  name="lona_lado"
                  value={form.lona_lado}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '2px solid #e1e8ed',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    transition: 'border-color 0.2s',
                    boxSizing: 'border-box'
                  }}
                >
                  <option value="">Selecione o lado</option>
                  <option value="esquerdo">Esquerdo</option>
                  <option value="direito">Direito</option>
                  <option value="ambos">Ambos os lados</option>
                </select>
                {form.lona_lado && form.lona_lado !== 'ambos' && (
                  <p style={{ 
                    marginTop: '8px', 
                    fontSize: '13px', 
                    color: '#ff9800',
                    fontWeight: '500',
                    background: '#fff3e0',
                    padding: '8px 12px',
                    borderRadius: '6px',
                    border: '1px solid #ffe0b2'
                  }}>
                    ⚠️ Atenção: A carreta permanecerá na lista de pendências até que ambos os lados sejam feitos.
                  </p>
                )}
              </div>
            )}

            <div className="manutencao-form-group">              <label>Responsável pela manutenção:</label>
              <input
                type="text"
                name="usuario"
                value={form.usuario}
                onChange={handleChange}
                placeholder="Nome do responsável"
                required
              />
            </div>

            <div className="manutencao-form-group">
              <label>Observações sobre a manutenção:</label>
              <textarea
                name="observacoes_manutencao"
                value={form.observacoes_manutencao}
                onChange={handleChange}
                placeholder="Descreva o que foi realizado, peças trocadas, etc."
                rows={4}
              />
            </div>
          </div>

          <div className="manutencao-modal-footer">
            <button type="button" className="manutencao-btn-cancel" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="manutencao-btn-submit">
              Registrar Manutenção
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ManutencaoModal;
